import Home from "./components/Home";
import Playfools from "./components/Playfools";
import Navbar from "./components/navbar/Navbar";
import Who from "./components/Who";
import Pageme from "./components/Pageme";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="w-full h-auto bg-black text-white">
      <div className="max-w-screen-2xl mx-auto">
        <Navbar />
        <Home />
        <Who />
        <Playfools />
        <Pageme />
        <Footer />
      </div>
    </div>
  );
}

export default App;
